import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpClientSecured } from '../services/http-client-secured';
import { Observable } from 'rxjs';
import { ISucursal } from './sucursal';
import { map } from 'rxjs/operators';
import * as myGlobals from './../global';

@Injectable({
  providedIn: 'root'
})
export class SucursalesService {
  private _sucursalesURL = myGlobals.baseApi + '/webadmin/v1/merchants';
  private _addSucursalURL = myGlobals.baseApi + '/webadmin/v1/merchant';
  formData: ISucursal;

  constructor(private http: HttpClientSecured, private httpClientSecured: HttpClientSecured) {}

  getSucursales() {
    console.log('getSucursales calles with httpClientSecured');
    return this.httpClientSecured.get<any>(this._sucursalesURL);
  }

  getSucursal(id: number): Observable<ISucursal | undefined> {
    return this.getSucursales().pipe(map((sucursales: ISucursal[]) => sucursales.find(p => p.id === id)));
  }

  addSucursal(sucursal) {
    return this.http.post<any>(this._addSucursalURL, sucursal);
  }
}
